<template>
  <div>
    <FormFieldLabel v-if="label" :for="`${id}_input`">
      {{ label }}
    </FormFieldLabel>
    <div class="relative rounded-md">
      <input
        :id="`${id}_input`"
        :type="type"
        :name="name"
        :class="[
          'block w-full rounded-md border border-background-fg/8 text-sm font-semibold focus:outline-none sm:text-sm',
          hasError
            ? 'border-error text-error placeholder:text-error focus:border-error focus:ring-error'
            : 'focus:border-primary focus:ring-primary',
        ]"
        :placeholder="placeholder"
        :value="inputValue"
        :aria-invalid="hasError"
        enterkeyhint="done"
        :disabled="disabled"
        :maxlength="maxlength"
        :pattern="pattern"
        @input="handleChange"
        @blur="handleBlur"
      />
    </div>
    <p
      v-if="hasError"
      class="mt-1 text-xs font-medium text-error"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

import { useId } from "vue"

const {
  type = "text",
  name,
  label,
  placeholder = "",
  disabled = false,
  maxlength = undefined,
  pattern = undefined,
} = defineProps<{
  type?: string
  name: string
  label: string
  placeholder?: string
  disabled?: boolean
  maxlength?: number
  pattern?: string
}>()

const id = useId()

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
} = useField(name)

const hasError = computed(() => !!errorMessage.value)
</script>
